var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconFacebook({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M12.7142857,31.66244 C5.45301429,30.147432 4.54747351e-13,23.7116996 4.54747351e-13,16 C4.54747351e-13,7.16206357 7.16206357,0 16,0 C24.8379364,0 32,7.16206357 32,16 C32,24.6946309 25.0683165,31.7672962 16.4285714,31.9943742 L16.4285714,19.5 L21.0714286,19.5 L22,15.6666667 L16.4285714,15.6666667 L16.4285714,13.75 C16.4285714,12.6958333 17.2642857,11.8333333 18.2857143,11.8333333 L22,11.8333333 L22,8 L18.2857143,8 C15.2158571,8 12.7142857,10.58175 12.7142857,13.75 L12.7142857,15.6666667 L9,15.6666667 L9,19.5 L12.7142857,19.5 L12.7142857,31.66244 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFacebook);
export default __webpack_public_path__ + "static/media/icon-facebook.b6851d58059e39caabca055a48d8c858.svg";
export { ForwardRef as ReactComponent };